export const buildSectionUrl = (pathname: string, sectionId: string): string => {
    const pathParts = pathname.split('/')
    pathParts.pop()
    pathParts.push(sectionId)
    return pathParts.join('/')
}